const ModuleIcon = ({ name, size = 32, color }) => {
  const icons = {
    Shield: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
      </svg>
    ),
    Warehouse: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
        <polyline points="9 22 9 12 15 12 15 22"/>
      </svg>
    ),
    Wrench: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/>
      </svg>
    ),
    ChartBar: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="12" y1="20" x2="12" y2="10"/>
        <line x1="18" y1="20" x2="18" y2="4"/>
        <line x1="6" y1="20" x2="6" y2="16"/>
      </svg>
    ),
    Mobile: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="5" y="2" width="14" height="20" rx="2" ry="2"/>
        <line x1="12" y1="18" x2="12.01" y2="18"/>
      </svg>
    )
  };

  return icons[name] || icons.Shield;
};

export const ModuleTile = ({ module, isFavorite, onToggleFavorite, onOpen }) => {
  const handleClick = () => {
    if (module.status !== 'coming_soon') {
      onOpen(module);
    }
  };

  const handleFavorite = (e) => {
    e.stopPropagation();
    onToggleFavorite(module.id);
  };

  const getStatusLabel = () => {
    if (module.status === 'coming_soon') return 'Coming Soon';
    return 'Online';
  };

  const getStatusClass = () => {
    if (module.status === 'coming_soon') return 'coming-soon';
    return 'online';
  };

  return (
    <div
      className={`module-tile ${module.status === 'coming_soon' ? 'disabled' : ''}`}
      onClick={handleClick}
      style={{ '--module-color': module.color }}
    >
      <div className="tile-header">
        <div
          className="tile-icon"
          style={{ backgroundColor: `${module.color}20` }}
        >
          <ModuleIcon name={module.icon} size={32} color={module.color} />
        </div>
        {module.status !== 'coming_soon' && (
          <button
            className={`favorite-btn ${isFavorite ? 'active' : ''}`}
            onClick={handleFavorite}
            aria-label={isFavorite ? 'Remove from favorites' : 'Add to favorites'}
          >
            {isFavorite ? '★' : '☆'}
          </button>
        )}
      </div>

      <div className="tile-body">
        <h3 className="tile-title">{module.name}</h3>
        <p className="tile-description">{module.description}</p>
      </div>

      <div className="tile-footer">
        <span className="tile-status">
          <span className={`status-dot ${getStatusClass()}`} />
          {getStatusLabel()}
        </span>
        {module.status !== 'coming_soon' && (
          <span className="tile-action">Open →</span>
        )}
      </div>
    </div>
  );
};

export default ModuleTile;
